import "./RangePickerComponentStyles.scss";
import { FC } from "react";
import RangePickerComponentProps from "./RangePickerComponentProps";
import { Slider, RangeSlider } from "rsuite";
import "rsuite/dist/rsuite.css";
import { ErrorMessage } from "@hookform/error-message";
import Validators from "../../../../utils/Validators";

const RangePickerComponent: FC<RangePickerComponentProps> = ({
    formFunctions,
    keyName,
    onChange,
    min,
    max,
    hiddenInputs = false,
    isCurrency = false,
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        watch,
    } = formFunctions;
    const minValue = watch(`${keyName}.min`);
    const maxValue = watch(`${keyName}.max`);

    const _handleChange = (value: number[]) => {
        setValue(`${keyName}.min`, value[0]);
        setValue(`${keyName}.max`, value[1]);
        onChange?.(value);
    };

    const _formatCurrency = (value: any): string => {
        if (value === undefined || value === null || value === "") return "";
        const number = typeof value === "number" ? value : parseInt(String(value).replace(/[^0-9]/g, ""), 10);
        return isNaN(number) ? "" : `$ ${number.toLocaleString("es-CO")}`;
    };

    const _handleCurrencyChange = (key: "min" | "max", rawValue: string) => {
        const digits = rawValue.replace(/[^0-9]/g, "");
        if (digits === "") {
            setValue(`${keyName}.${key}`, "", { shouldValidate: true });
            return;
        }
        const clamped = Math.min(parseInt(digits, 10), max);
        setValue(`${keyName}.${key}`, clamped, { shouldValidate: true });
    };

    return (
        <div className="range_picker_component my-3">
            <RangeSlider
                value={[minValue ?? min, maxValue == "" ? max : maxValue]}
                min={min}
                max={max}
                onChange={_handleChange}
            />
            <div className="div d-flex justify-content-between my-2">
                <div className="flex-grow-1 me-2">
                    <input
                        type={isCurrency ? "text" : "number"}
                        inputMode={isCurrency ? "numeric" : undefined}
                        value={isCurrency ? _formatCurrency(minValue) : minValue}
                        min={isCurrency ? undefined : min}
                        hidden={hiddenInputs}
                        max={isCurrency ? undefined : (maxValue ?? max)}
                        className="form-control"
                        placeholder="Mínimo"
                        {...register(
                            `${keyName}.min`,
                            Validators({
                                maxValue: maxValue ?? max,
                            }),
                        )}
                        {...(isCurrency
                            ? {
                                  onChange: (event: any) => _handleCurrencyChange("min", event.target.value),
                              }
                            : {})}
                    />
                </div>
                <div className="flex-grow-1 ms-2">
                    <input
                        type={isCurrency ? "text" : "number"}
                        inputMode={isCurrency ? "numeric" : undefined}
                        hidden={hiddenInputs}
                        value={isCurrency ? _formatCurrency(maxValue) : maxValue}
                        min={isCurrency ? undefined : (minValue ?? min)}
                        max={isCurrency ? undefined : max}
                        className="form-control"
                        placeholder="Máximo"
                        {...register(
                            `${keyName}.max`,
                            Validators({
                                minValue: minValue ?? min,
                            }),
                        )}
                        {...(isCurrency
                            ? {
                                  onChange: (event: any) => _handleCurrencyChange("max", event.target.value),
                              }
                            : {})}
                    />
                </div>
            </div>
            <ErrorMessage errors={errors} name={`${keyName}.min`} as="aside" />
            <ErrorMessage errors={errors} name={`${keyName}.max`} as="aside" />
        </div>
    );
};

export default RangePickerComponent;
